<template>
  <div>
    <b-row>
      <b-col>
        <card-list-info header="Prestart Detail" :items="detailInfo"></card-list-info>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <card-list-info header="Company Information" :items="companyInfo"></card-list-info>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import dateMixin from '@/mixins/date';
import CardListInfo from '@/components/CardListInfo';
import { isEmpty } from 'lodash';

export default {
  mixins: [dateMixin],
  components: {
    CardListInfo,
  },
  computed: {
    detailedInfo() {
      return this.$store.getters['question_prestart/get_detail_data'];
    },
    detailInfo() {
      const info = this.detailedInfo;
      let infoList = [];

      if (!isEmpty(info)) {
        const {
          driver, vehicle, created_at, status,
        } = info;
        const statusText = status === 'SUCCESS' ? 'PASS' : 'FAIL';
        infoList = [
          { key: 'driver', label: 'Driver', value: driver.name },
          { key: 'vehicle', label: 'Vehicle', value: vehicle.reg_no },
          { key: 'created_at', label: 'Datetime', value: this.formatDateTime(created_at) },
          { key: 'status', label: 'Status', value: statusText },
        ];
      }

      return infoList;
    },
    companyInfo() {
      const info = this.detailedInfo;
      let infoList = [];

      if (!isEmpty(info)) {
        const company = info.company || {};
        infoList = [
          { key: 'company', label: 'Name', value: company.name },
        ];
      }

      return infoList;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/pages/question_prestart/detail/Index.vue